import { useContext,useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import CancellationPolicyDayRentalServices from "services/CancellationPolicyDayRentalServices";
import { notifyError, notifySuccess } from "utils/toast";

const useCancellationPolicyDayRentalSubmit = (id) => {
  const { setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [inclusion, setInclusion] = useState("");
  const [exclusion, setExclusion] = useState("");
  const [termsCondition, setTermsCondition] = useState("");
  const [cancelPolicy, setCancelPolicy] = useState("");
  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      const datas = {
        tax: data.tax,
        // tds:data.tds,
        inclusion: inclusion,
        exclusion: exclusion,
        terms_condition: termsCondition,
        cancel_policy: cancelPolicy,
      };

      if (id) {
        const res = await CancellationPolicyDayRentalServices.updatePolicy(id, datas);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
      } 
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
    }
  };

  const getPolicyData = async () => {
    try {
      const res = await CancellationPolicyDayRentalServices.getPolicyById(id, {
      });
      if (res) {
        setValue("tax", res.tax);
        // setValue("tds",res.tds);
        setInclusion(res.inclusion);
        setExclusion(res.exclusion);
        setTermsCondition(res.terms_condition);
        setCancelPolicy(res.cancel_policy);
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };
  useEffect(() => {
    if (id) {
        getPolicyData();
      }
     // eslint-disable-next-line
  }, [id]);

  return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    isSubmitting,
    setInclusion,
    setExclusion,
    inclusion,
    exclusion,
    cancelPolicy,
    setTermsCondition,
    setCancelPolicy,
    termsCondition,
  };
};

export default useCancellationPolicyDayRentalSubmit;
